var map = {
	"./CHD.png": 175,
	"./CHR.png": 176,
	"./about-background-2.jpg": 177,
	"./background-about-us.jpg": 178,
	"./banner-home.jpg": 179,
	"./bg.svg": 212,
	"./fish.png": 210,
	"./logo.png": 209,
	"./products/barcoded-labels.png": 213,
	"./products/computer-labels.png": 214,
	"./products/domed-labels.png": 215,
	"./products/embossed-labels.png": 216,
	"./products/numbering.png": 217,
	"./products/overprinted.png": 218,
	"./products/plain-labels.png": 219,
	"./products/printed-labels.png": 220,
	"./products/security-labels.png": 221,
	"./products/split-lam-labels.png": 222,
	"./products/window-sticker.png": 223,
	"./sample-pack.jpg": 160,
	"./sampleget.gif": 224,
	"./services/digital.jpg": 180,
	"./services/digital_small.jpg": 181,
	"./services/hotfoil.jpg": 182,
	"./services/hotfoil_small.jpg": 183,
	"./services/letterpress.jpg": 184,
	"./services/letterpress_small.jpg": 185,
	"./services/thermal.jpg": 186,
	"./services/thermal_small.jpg": 187,
	"./team/Andrew.jpg": 225,
	"./team/Ben.jpg": 226,
	"./team/Caitlin.jpg": 227,
	"./team/Carol.jpg": 228,
	"./team/Chris.jpg": 229,
	"./team/Darran.jpg": 230,
	"./team/Gail.jpg": 188,
	"./team/Gill.jpg": 231,
	"./team/Karen.jpg": 232,
	"./team/Mike.jpg": 189,
	"./team/Paul.jpg": 190,
	"./trade-only-white.png": 196,
	"./trade-only.png": 233,
	"./unsplash/jeremy-galliani-567479-unsplash.jpg": 234,
	"./unsplash/markus-spiske-445251-unsplash.jpg": 235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;